import React from 'react';
import {
  Box,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import ModernNavbar from '../Common/ModernNavbar';
import Footer from './Footer';
import SupportChatWidget from '../SupportChatWidget';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  // Hide footer on chat pages to give more space for messages
  const isChatPage = location.pathname.startsWith('/inbox');
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ModernNavbar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          pt: { xs: '88px', md: '92px' }, // Add padding top to account for fixed navbar (top: 16 + toolbar height ~60-64px)
          ...(isChatPage && {
            height: 'calc(100vh - 104px)', // Full height minus navbar on mobile
            '@media (min-width: 900px)': {
              height: 'calc(100vh - 114px)', // Full height minus navbar on desktop
            },
            overflow: 'hidden', // Prevent page scroll on chat pages
          }),
        }}
      >
        {children}
      </Box>
      {!isChatPage && <Footer />}
      <SupportChatWidget />
    </Box>
  );
};

export default MainLayout;